import { type ComboboxItem } from "@mantine/core";

/** Generates an array of select choices from 1 to `days`.*/
export function getDayChoicesFromDays(days: number): Array<ComboboxItem> {
  return Array.from({ length: days }, (_, i) => ({
    value: (i + 1).toString(),
    label: (i + 1).toString()
  }));
}
